#import "@/apollo/fragments/Client.gql"

query Navigation($orderBy: ClientOrderBy, $wppProjectId: String) {
    clients(orderBy: $orderBy, wppProjectId: $wppProjectId) {
        ...Client
    }
}
